import React from 'react'
import Home from './Pages/Home'
import { Route, Routes } from 'react-router-dom';
import Review from './Pages/Review';
import CheckInpage from './CheckInpage';
import GMB from './Pages/GMB';
import Social from './Pages/Social';
import Market from './Pages/Market';
import Comms from './Pages/Comms';
import Support from './Pages/Support';
import Ads from './Pages/Ads';
import Payments from './Pages/Payments';
import Contactcenter from './Pages/Contactcenter';
import SurveyPage from './Survey/SurveyPage';
import PrivacyPolicy from './PrivacyPolicy';


function AppRoutes() {
  return (
    <div className="w-full h-full ">
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reviews-management" element={<Review />} />
            <Route path="/business-management" element={<GMB />} />
            <Route path="/social-management" element={<Social />} />
            <Route path="/marketing-management" element={<Market/>} />
            <Route path="/messaging-management" element={<Comms/>} />
            <Route path="/ticketing-management" element={<Support />} />
            <Route path="/contact-center" element={<Contactcenter />} />
            <Route path="/ad-management" element={<Ads />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />






            {/* <Route path="/survey" element={<SurveyPage />} /> */}

            <Route path="/waitlist" element={<CheckInpage />} />


        </Routes>
      
    </div>
  )
}

export default AppRoutes
